module.exports = __webpack_public_path__ + "static/media/grooming.023a56f4.jpg";